import React, { useState } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { FiCalendar } from "react-icons/fi";


const AddLeaveModal = ({ show, handleClose }) => {
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(new Date());

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="lg"
      dialogClassName="custom-modal"
    >
      {/* HEADER */}
      <Modal.Header closeButton className="modal-header-custom">
        <Modal.Title>Add Leave</Modal.Title>
      </Modal.Header>

      {/* BODY */}
      <Modal.Body className="modal-body-custom">
        <Form>

          {/* Employee */}
          <Form.Group className="mb-3">
            <Form.Label>Employee Name</Form.Label>
            <Form.Select className="custom-input">
              <option>Select</option>
              <option>Vamsi Kumar</option>

              <option>Krisshan</option>

              <option>cummins</option>

            </Form.Select>
          </Form.Group>

          {/* Leave Type */}
          <Form.Group className="mb-3">
            <Form.Label>Leave Type</Form.Label>
            <Form.Select className="custom-input">
              <option>Select</option>
              <option>Medical Leave</option>
              <option>Sick Leave</option>
              <option>Casual Leave</option>

            </Form.Select>
          </Form.Group>

          {/* DATE ROW */}
          <Row className="mb-3">
            <Col md={6}>
              <Form.Label>From</Form.Label>
              <div className="date-input">
                <DatePicker
                  selected={fromDate}
                  onChange={(date) => setFromDate(date)}
                  placeholderText="dd/mm/yyyy"
                  dateFormat="dd-MM-yyyy"
                  className="custom-input"
                />
                <FiCalendar className="calendar-icon" />
              </div>
            </Col>

            <Col md={6}>
              <Form.Label>To</Form.Label>
              <div className="date-input">
                <DatePicker
                  selected={toDate}
                  onChange={(date) => setToDate(date)}
                  dateFormat="dd-MM-yyyy"
                  className="custom-input"
                />
                <FiCalendar className="calendar-icon" />
              </div>
            </Col>
          </Row>

          {/* DAYS */}
          <Row className="mb-3">
            <Col md={6}>
              <Form.Label>No of Days</Form.Label>
              <Form.Control className="custom-input" />
            </Col>

            <Col md={6}>
              <Form.Label>Remaining Days</Form.Label>
              <Form.Control
                className="custom-input"
                value="8"
                readOnly
              />
            </Col>
          </Row>

          {/* REASON */}
          <Form.Group className="mb-3">
            <Form.Label>Reason</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              className="custom-input"
            />
          </Form.Group>

        </Form>
      </Modal.Body>

      {/* FOOTER */}
      <Modal.Footer className="modal-footer-custom">
        <Button className="btn-cancel" onClick={handleClose}>
          Cancel
        </Button>
        <Button className="btn-add">
          Add Leave
        </Button>
      </Modal.Footer>
      <style>{`/* MODAL */
.custom-modal .modal-content {
  border-radius: 10px;
  border: none;
}

/* HEADER */
.modal-header-custom {
  border-bottom: 1px solid #eee;
  padding: 16px 20px;
}

.modal-header-custom .modal-title {
  font-size: 20px;
  font-weight: 600;
}

/* BODY */
.modal-body-custom {
  padding: 20px;
}

/* INPUT */
.custom-input {
  height: 42px;
  border-radius: 6px !important;
  border: 1px solid #e5e7eb !important;
  font-size: 14px;
}

/* TEXTAREA */
textarea.custom-input {
  height: 100px;
}

/* DATE INPUT */
.date-input {
  position: relative;
}

.calendar-icon {
  position: absolute;
  right: 170px;
//   top: 12px;
  color: #6b7280;
  pointer-events: none;
}

/* FOOTER */
.modal-footer-custom {
  border-top: 1px solid #eee;
  padding: 16px 20px;
  justify-content: flex-end;
}

/* BUTTONS */
.btn-cancel {
  background: #f3f4f6 !important;
  border: none !important;
  color: #111;
  padding: 8px 18px;
  border-radius: 6px;
}

.btn-add {
  background: #f97316 !important;
  border: none !important;
  padding: 8px 18px;
  border-radius: 6px;
}

/* DATE PICKER STYLE (IMPORTANT) */
.react-datepicker {
  border-radius: 10px !important;
  border: 1px solid #eee !important;
}

.react-datepicker__day--selected {
  background-color: #f97316 !important;
  border-radius: 6px !important;
}

.react-datepicker__header {
  background-color: #fff !important;
  border-bottom: none !important;
}

/* MOBILE */
@media (max-width: 768px) {
  .modal-body-custom {
    padding: 15px;
  }

  .modal-footer-custom {
    flex-direction: column;
    gap: 10px;
  }

  .btn-cancel,
  .btn-add {
    width: 100%;
  }
}`}</style>
    </Modal>
  );
};

export default AddLeaveModal;